export default __webpack_public_path__ + "static/media/job-offer.845c89d5.png";